import { protectedRoute } from "../config/api.config";

export function getMessagesAPI({ queryKey, pageParam = 0 }) {
  const [, limit, channelId] = queryKey;
  return protectedRoute.get('/messages', { params: { limit, skip: pageParam * limit, channelId, sortOrder: 'desc' } });
}

export function getLastMessagesAPI() {
  return protectedRoute.get('messages/last-messages');
}

export function editMessagesAPI({ messageId, text, fileURL = [], type = "TEXT" }) {
  return protectedRoute.patch(`/messages/edit/${messageId}`, {
    text,
    fileURL,
    type,
  });
}

export function deleteMessagesAPI({ messageId }) {
  return protectedRoute.delete(`/messages/delete/${messageId}`);
}


// export function sendMessagesAPI(payload) {
//   return protectedRoute.post('/messages/send', payload);
// }